import React from 'react';
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { StyledTabComponent, StyledTabInner, StyledNonTabHeadline } from './tab-container.style';

type ITabItem = [string, React.ReactElement];

export interface ITabContainer {
    items: ITabItem[];
}

export const TabContainer = ({ items }: ITabContainer) => {
    const [view, setView] = React.useState(0);

    // tslint:disable-next-line: variable-name
    const handleChange = (_event: any, newValue: any) => {
        setView(newValue);
    };

    const isSingleView = items.length === 1 ? true : false;

    return (
        <StyledTabComponent>
            {isSingleView ? (
                <StyledNonTabHeadline>{items[0][0]}</StyledNonTabHeadline>
            ) : (
                <Tabs value={view} onChange={handleChange} variant={'fullWidth'}>
                    {items.map((item) => (
                        <Tab key={item[0]} label={item[0]} />
                    ))}
                </Tabs>
            )}
            <SwipeableViews index={view} onChangeIndex={(index) => setView(index)}>
                {items.map((item) => (
                    <StyledTabInner key={item[0]} isSingleView={isSingleView}>
                        {item[1]}
                    </StyledTabInner>
                ))}
            </SwipeableViews>
        </StyledTabComponent>
    );
};
